// src/components/RootRoute.jsx

import React from "react";
import { useAuth } from "../context/AuthContext";
import Inicio from "../paginas/Inicio";
import Entrar from "../paginas/Entrar";
import Dashboard from "../paginas/Dashboard";
import LoginPage from "../paginas/LoginPage";
import { Navigate } from "react-router-dom";
import HeaderDash from "./Header";
import MenuDrawer from "./MenuDrawer";
import CommercialProfileSetup from "../paginas/CommercialProfileSetup";

const RootRoute = () => {
  const { isAuthenticated, user } = useAuth();

  // Detecta se o acesso veio pelo domínio do parceiro OctoSoft
  const isOctoSoft = window.location.hostname.includes("octosoft.com.br");

  // Se o usuário estiver logado mas não configurou a loja/perfil
  if (user && user.store_id == null) {
    return <CommercialProfileSetup />;
  }

  // Se estiver autenticado, mostra o Painel/Dashboard normal
  if (isAuthenticated) {
    return (
      <MenuDrawer>
        <Dashboard />
      </MenuDrawer>
    );
  }

  // Se NÃO estiver autenticado:
  // Se for OctoSoft, vai direto para a tela de Login
  if (isOctoSoft) {
    return <Entrar />; // Ou se preferir: <Navigate to="/auth/login" replace />
  }

  // Se for o domínio principal da FazPedido, mostra a Landing Page
  return <Inicio />;
};

export default RootRoute;